<template>
    <div class="row justify-content-center u-mt2 has-margins">
        <div class="col-12 col-xs-12 col-md-6">
            <div class="u-form u-mt1">
                <loading :loading="loading"></loading>
                <h3 class="u-mt2" v-if="user.is_creator">Upgrade storage</h3>
                <h3 class="u-mt2" v-else>Upgrade</h3>
                <p v-if="user.is_creator">
                    If you would like to add more storage space, you can do so for a small cost.
                    You currently have {{bytes.purchased | fileSize}} space, of which you have used
                    {{bytes.used | fileSize}}, meaning that you have {{bytes.available | fileSize}} remaining.
                </p>
                <p v-else>
                    If you would like to keep in touch with your loved ones when you are
                    no longer around, you can upgrade to a premium account.  The price of
                    this is based on the amount of content you would like to upload and the
                    length of time you would like us to keep hold of that content.
                </p>
                <div class="form-group" v-if="!user.is_creator">
                    <label for="timeRange">How long should we keep your data?</label>
                    <select class="form-control" v-model="time">
                        <option :value="t" v-for="t in years" v-bind:key="t">{{showYears(t)}}</option>
                    </select>
                    <p class="help-text -strong">{{showTime}}</p>
                </div>

                <div class="form-group">
                    <ion-label for="spaceRange">How much storage?</ion-label>
                    <select class="form-control" v-model="space">
                        <option :value="g" v-for="g in gbs" v-bind:key="g">{{showGbs(g)}}</option>
                    </select>
                    <p class="help-text -strong">{{showSpace}}</p>
                    <p class="help-text">
                        {{showSpaceHelper}}
                    </p>
                </div>

                <div class="-price">
                    {{moneyFormat(price)}}
                </div>

                <div class="u-mt1 text-center" :class="paying ? 'invisible' : 'visible'">
                    <div id="paypalUpgradeButton" class="paypalButton"></div>
                </div>

                <div class="u-mt1 text-center" v-if="paying">
                    <i class="fas fa-circle-notch fa-spin fa-3x"></i>
                </div>
                <ion-button shape="round" expand="full" v-on:click="onCancel()" color="medium" style="color : var(--ion-color-dark);">Cancel</ion-button>
            </div>
        </div>
    </div>
</template>

<script>


import Loading from '@/components/Loading.vue';
import {alerts} from '@/mixins/alerts';
import {registration} from '@/mixins/registration';
import {formatting} from '@/mixins/formatting';
export default {
    mixins : [alerts, registration, formatting],
    name: 'upgrade',
    data : function () {
        return {
            errors  : {},
            posting : false,
            time    : 5,
            space   : 2000,
            paid    : false,
            paying  : false,
            paypal  : {},
            loading : true,
            bytes   : {
                used      : 0,
                purchased : 0,
                available : 0
            }
        }
    },
    props : {
        onCancel : {
            type : Function,
            default : function () {
                this.$router.push({ name : 'profile' });
            }
        },
        onSuccess : {
            type : Function,
            default : function () {
                this.$router.push({ name : 'home' });
            }
        }
    },
    mounted : function () {
        this.renderPaypal();
        if (this.user.is_creator) {
            this.time = parseInt(this.$root.user.years); // odd this...
            // get the storage...
            this.checkSpace();
        } else {
            this.loading = false;
        }
    },
    components : {
        Loading
    },
    computed : {
        user : function () {
            return this.$root.user;
        }
    },
    methods : {
        checkSpace : function () {
            let self = this;
            this.loading = true;
            this.axios.get(this.api + 'users/space')
                .then(response => {
                    self.bytes = response.data;
                    self.loading = false;
                })
                .catch(error => {
                    self.loading = false;
                    console.error('error setting space', error);
                });
        },
        showYears : function (t) {
            if (t == 1) {
                return '1 Year';
            }
            return t + ' Years';
        },
        showGbs : function (g) {
            if (g == 500) {
                return '500MB';
            }
            let gb = g / 1000;
            return gb + 'GB';
        },
        renderPaypal : function () {
            let self = this;
            this.axios.get(this.api + 'paypal')
                .then(response => {
                    let env    = response.data.env,
                        client = response.data.client; // eslint-disable-next-line
                    paypal.Button.render({
                        env     : env,
                        client  : client, // eslint-disable-next-line
                        payment : function (data, actions) {
                            self.paying = true;  // eslint-disable-next-line
                            return new paypal.Promise(function(resolve, reject) {
                                let params = {
                                    id    : self.user.id,
                                    space : self.space,
                                    time  : self.time,
                                    price : self.price
                                };
                                self.axios.post(self.api + 'paypal/upgrade', params)
                                    .then(response => {
                                        resolve(response.data.paymentID);
                                    })
                                    .catch(error => {
                                        var msg = 'There was a problem processing that request. Please check the details you provided.';
                                        if (error.response && error.response.data && error.response.data.error) {
                                            msg = error.response.data.error;
                                        }
                                        self.showError(msg);
                                        self.paying = false;
                                        reject(error);
                                    });
                            });
                        },
                        onAuthorize : function (data) {
                            console.debug('payment authorised', data);
                            self.axios.post(self.api + 'paypal/complete', data)
                                .then(() => {
                                    self.paying = false;
                                    let msg = 'Thanks for your payment, you should now be able to upload content.  If there are any issues, please try logging out and logging back in.';
                                    if (self.user.is_creator) {
                                        msg = 'Thanks for your payment, your storage allowance has been upgraded.  If there are any issues, please try logging out and logging back in.';
                                    }
                                    self.showSuccess(msg, function () {
                                        self.axios.post(self.api + 'auth/me')
                                            .then(response => {
                                                self.$root.setUser(response.data);
                                                self.onSuccess();
                                            })
                                            .catch(error => {
                                                console.error('ERROR getting me', error);
                                            });
                                    });
                                })
                                .catch(error => {
                                    var msg = 'There was a problem authorising that payment.';
                                    if (error.response && error.response.data && error.response.data.error) {
                                        msg = error.response.data.error;
                                    }
                                    self.showError(msg);
                                    self.paying = false;
                                });
                        }, // eslint-disable-next-line
                        onCancel : function (data) {
                            self.paying = false;
                            // self.onCancel();
                        },
                        onError : function (error) {
                            self.paying = false;
                            console.error('paypal error', error);
                        },
                        style: {
                            size    : 'medium',
                            color   : 'gold',
                            shape   : 'pill',
                            locale  : 'en_GB',
                            tagline : true
                        }
                    }, '#paypalUpgradeButton');

                })
                .catch(error => {
                    console.error('Could not get paypal client details', error);
                });
        }
    }
}
</script>>

<style>
.-price {

    font-weight : 600;
    color : var(--ion-color-dark);
    font-size : 1.2rem;
}
.help-text {
    color : var(--ion-color-medium);
    font-weight : 100;
    text-align : left;
}
.help-text.-strong {
    font-weight : 600;
    color : var(--ion-color-dark);
}
input[type=range] {
  -webkit-appearance: none;
  width: 100%;
  margin: 5px 0;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  background: var(--ion-color-light);
  border-radius: 2px;
  border: 0px solid #ffffff;
}
input[type=range]::-webkit-slider-thumb {
  border: 1px solid #ffffff;
  height: 16px;
  width: 16px;
  border-radius: 8px;
  background: var(--ion-color-primary);
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -5px;
}
input[type=range]:focus::-webkit-slider-runnable-track {
  background: var(--ion-color-light);
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  background: var(--ion-color-light);
  border-radius: 2px;
  border: 0px solid #ffffff;
}
input[type=range]::-moz-range-thumb {
  border: 1px solid #ffffff;
  height: 16px;
  width: 16px;
  border-radius: 8px;
  background: var(--ion-color-dark);
  cursor: pointer;
}
input[type=range]::-ms-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type=range]::-ms-fill-lower {
  background: var(--ion-color-dark);
  border: 0;
  border-radius: 4px;
}
input[type=range]::-ms-fill-upper {
  background: var(--ion-color-dark);
  border: 0;
  border-radius: 4px;
}
input[type=range]::-ms-thumb {
  border: 1px solid #ffffff;
  height: 16px;
  width: 16px;
  border-radius: 8px;
  background: var(--ion-color-primary);
  cursor: pointer;
  height: 6px;
}
input[type=range]:focus::-ms-fill-lower {
  background: #495b64;
}
input[type=range]:focus::-ms-fill-upper {
  background: #546873;
}

</style>
